module.exports = __webpack_public_path__ + "static/media/bingerville_logo.fd7a36e4.jpg";